import React, { useState , useEffect} from "react";
import "./styles.css";

import Header from "./components/Header";
import CreateArea from "./components/CreateArea";
import Note from "./components/Note";
import Count from "./components/Count";
import Footer from "./components/Footer";



// getting the values of local storage
const getDatafromLS=()=>{
  const data = localStorage.getItem('notes');
  if(data){
    return JSON.parse(data);
  }
  else{
    return []
  }
}

function App(props) {
  const [notes, setNotes] = useState(getDatafromLS());


  function addNote(newNote) {
    setNotes((prevValue) => {
      return [...prevValue, newNote];
    });
  }

  function deleteNotes(id) {
    setNotes((preValue) => {
      return [...preValue.filter((note, index) => index !== id)];
    });
  }

// saving data to local storage
useEffect(()=>{
  localStorage.setItem('notes',JSON.stringify(notes));
},[notes])




  return (
    <div className="App">
      <Header />
      <Count
        count={
          notes.length === 0
            ? "Empty"
            : `Showing ${notes.length} Notes in Database`
        }
      />
      <CreateArea onAdd={addNote} />
      {notes.map((note, index) => (
        <Note
          key={index}
          id={index}
          title={note.title}
          content={note.content}
          onDelete={deleteNotes}
        />
      ))}
      <Footer />
    </div>
  );
}

export default App;
